import { TableCell, Typography } from '@mui/material';

// ----------------------------------------------------------------------

type Props = {
  key: string;
  value: any;
  headerIndex: number;
};

export function RowCellLearningQA({ key, value, headerIndex }: Props) {
  return (
    <TableCell key={key || headerIndex} sx={{ maxWidth: key === 'question' ? 300 : 400 }}>
      <Typography
        variant="body2"
        noWrap
        title={String(value ?? '')}
        color={key === 'answer' ? 'text.secondary' : 'text.primary'}
      >
        {String(value ?? '')}
      </Typography>
    </TableCell>
  );
}
